import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import { fetchOutreaches as fetchOutreachesRoutine } from './routines';

export const fetchOutreaches = ({ payload: qs }) =>
  sagaRoutineRequest(fetchOutreachesRoutine, {
    request: () => call(Api.fetchOutreaches, { qs })
  });
